import { getLanguageFromStorage, triggerAnalyticsEvent, } from "syf-js-utilities";
import getCorrelationId from "./getCorrelationId";
import { getProfileClient } from "./profileSessionStorage";
import { DEFAULTS } from "../const/analytics";
var triggerAnalytics = function (_a) {
    var _b = _a.pageFunction, pageFunction = _b === void 0 ? DEFAULTS.PAGE_FUNCTION : _b, _c = _a.pageKind, pageKind = _c === void 0 ? DEFAULTS.PAGE_KIND : _c, _d = _a.pageName, pageName = _d === void 0 ? DEFAULTS.PAGE_NAME : _d, _e = _a.product, product = _e === void 0 ? DEFAULTS.PRODUCT : _e, _f = _a.pageSubFunction, pageSubFunction = _f === void 0 ? DEFAULTS.SUB_FUNCTION : _f, _g = _a.errorMessage, errorMessage = _g === void 0 ? DEFAULTS.ERROR_MESSAGE : _g, _h = _a.messageType, messageType = _h === void 0 ? errorMessage : _h;
    triggerAnalyticsEvent({
        pageFunction: pageFunction,
        messageType: messageType,
        token: getCorrelationId(),
        pageName: pageName,
        pageSubFunction: pageSubFunction,
        countryLanguage: "us|".concat(getLanguageFromStorage()),
        clientName: getProfileClient(),
        customerType: DEFAULTS.CUSTOMER_TYPE,
        pageKind: pageKind,
        product: product,
    });
};
export default triggerAnalytics;
